const PROLIFIC_WRITERS = [
  'alley_skywalker', 'arbitrarily', 'arithanas', 'assimbya', 'astrokath', 'beatrice_otter', 'betony', 'brutti_ma_buoni', 'carolinecrane', 'chibifukurou', 'chicafrom3', 'chokolattejedi', 'cjmarlowe', 'damkianna', 'donutsweeper', 'escritoireazul', 'esteliel', 'estirose', 'eustaciavye', 'executrix', 'fabrisse', 'finch', 'flipflop_diva', 'fresne', 'greerwatson', 'halotolerant', 'haywire', 'htbthomas', 'innie', 'joanne_c', 'kalypsobean', 'karanguni', 'katayla', 'keerawa', 'laughingpineapple', 'lightningwaltz', 'longwhitecoats', 'mardia', 'marks', 'measured_words', 'merryghoul', 'miss_m', 'misura', 'mithen', 'mithrigil', 'nary', 'nightsmistress', 'nomadicwriter', 'plinys', 'primeideal', 'prosodiical', 'psychomachia', 'russian_blue', 'sadlikeknives', 'sarren', 'settiai', 'sevenofspade', 'skazka', 'spock', 'sumi', 'the_alchemist', 'thedevilchicken', 'tlvop', 'tuesday', 'voleuse', 'yhlee (etothey)'
]; 
const CRUELTIDE = [
  'comixologist', 
  'red_terra',
  'prodigy',
  'keerawa',
  'gaialux',
  'vampirepaladin',
  'scribe_of_mirrormere',
  'merryghoul',
  'falsteloj',
  'evilmuffins',
  'skazka',
  'ahavah',
  'blahblahwhy',
  'apricot',
  'effectaffect',
  'notearchiver',
  'russian_blue',
  'alchemise',
  'spock',
  'ideallyqualia',
  'havisham',
  'days4daisy',
  'reeby10',
  'tristesses',
  'radioqueen',
  'derogatory',
  'amyfortuna',
  'esteliel',
  'calliopes_pen',
  'aeriel',
  'dancingsalome',
  'snowynight',
  'geckoholic',
  'soundandcolor',
  'corik',
  'tuesday',
  'shadow_lover',
  'starlatine',
  'plinys',
  'republic',
  'the_wavesinger',
  'makiyakinabe',
  'the_alchemist',
  'skitz_phenom',
  'this',
  'bonster',
  'naughtyanne',
  'kutsushita',
  'applebutter',
  'originally',
  'major',
  'laylah'
];
const YULEPORN = [
  'effectaffect',
  'rubylily',
  'miss_terra',
  'caudipteryx',
  'scribe_of_mirrormere',
  'laylah',
  'skazka',
  'days4daisy',
  'airgiodslv',
  'merryghoul',
  'gayporwave',
  'keerawa',
  'tearoses',
  'gaialux',
  'scribblemyname',
  'the_anglophile',
  'extrapenguin',
  'aunt_zelda',
  'falsteloj',
  'evilmuffins',
  'aurilly',
  'ahavah',
  'apricot',
  'sandrine',
  'linndechir',
  'comixologist',
  'galerian_ash',
  'croik',
  'storiesfortravellers',
  'theoldgods',
  'spock',
  'reeby10',
  'the_plaid_slytherin',
  'havisham',
  'starlatine',
  'lady_ganesh',
  'dryad',
  'tristesses',
  'slr2moons',
  'undomielregina',
  'brampersandon',
  'wiseorfool',
  'hearteating',
  'malkontent',
  'blueteak',
  'isis',
  'amyfortuna',
  'esteliel',
  'coaldustcanary',
  'deifire',
  'geckoholic',
  'carolinecrane',
  'musyc',
  'muccamukk',
  'soundandcolor',
  'tuesday',
  'sath',
  'radioqueen',
  'shadow_lover',
  'fairestcat',
  'deepdarkwaters',
  'toft',
  'lilybeth84',
  'novembersmith',
  'atlanticslide',
  'celeste9',
  'halfeatenmoon',
  'etnoe',
  'doreyg',
  'plinys',
  'blue_eyesgirl_fic',
  'republic',
  'beedekka',
  'hiddencait',
  'hellabaloo',
  'ozsaur',
  'skitz_phenom',
  'echoslammin',
  'pajamasecrets',
  'brigdh',
  'trillingstar',
  'spankedbyspike',
  'kutsushita',
  'jougetsu',
  'weakinteraction',
  'abluestocking',
  'the_wavesinger',
  'originally',
  'rosedamask'
];
const FESTIVUS = [
  'saiditallbefore',
  'sath',
  'keerawa',
  'rubylily',
  'tearoses',
  'lionessvalenti',
  'gayporwave',
  'triplesalto',
  'tekuates',
  'chantefable',
  'merryghoul',
  'snowynight',
  'muccamukk',
  'mlraven',
  'edonohana',
  'starlatine',
  'theoldgods',
  'scioscribe',
  'elwing_alcyone',
  'hiddencait',
  'yhlee (etothey)',
  'ephemeralblossom',
  'pyrophane',
  'ideallyqualia',
  'aunt_zelda',
  'hauntedd',
  'inkyrius',
  'lalalalalawhy',
  'idleflower',
  'utsusemi',
  'elfwreck',
  'ahavah',
  'shadaras',
  'napkins',
  'phidari',
  'bygoshbygolly',
  'alliterate',
  'effectaffect',
  'tristesses',
  'snickfic',
  'isis',
  'glitterpig',
  'sophiahelix',
  'serenadestrong',
  'deifire',
  'malkontent',
  'skazka',
  'sineala',
  'hyenateeth',
  'tuesday',
  'ambyr',
  'basketofnovas (slashmarks)',
  'azurish',
  'impertinency',
  'halfeatenmoon',
  'hellabaloo',
  'mapped',
  'mammothluv',
  'gramarye',
  'rinadoll',
  'zdenka',
  'jougetsu',
  'assimbya',
  'shopfront',
  'the_wavesinger',
  'reconditarmonia',
  'originally',
  'minim_calibre'
];

export {
  PROLIFIC_WRITERS,
  CRUELTIDE,
  YULEPORN,
  FESTIVUS
};


// WEBPACK FOOTER //
// ./src/data/lists.js